import { Modal } from '@/components/ui/Modal';
import { GuideContent } from './GuideContent';

// In-app quick-access wrapper for the bilingual guide — a Modal around the
// shared GuideContent. The same content is also reachable as a full page at
// /guide (opened in a new tab from camera settings). No Modal title is passed:
// GuideContent renders its own header + close X so the modal and the page
// share one chrome. Additive feature — no existing flow is touched.

interface GuideHelpProps {
  open: boolean;
  onClose: () => void;
}

export const GuideHelp = ({ open, onClose }: GuideHelpProps) => (
  <Modal open={open} onClose={onClose} size="lg">
    <GuideContent onClose={onClose} />
  </Modal>
);
